import { React, useState, useEffect } from 'react'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip } from "@material-ui/core"
import InfoIcon from '@material-ui/icons/Info';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSnackbar } from 'notistack';
import { globalPutService, globalPostService, globalGetService } from '../../../utils/globalApiServices';
import { PageLoader } from '../../../shared_elements';
import { checkApiStatus } from '../../../utils'
import { configDataObj } from '.';
import { trackActivity } from '../../../utils/mixpanel';

function AddEditConfigure({ toggleModalFn, configData, modeType, getResponseBack }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [data, setData] = useState(configData ? configData : configDataObj)
    const [error, setError] = useState({})
    const [isLoading, setLoading] = useState(false)
    const [engineType, setEngineType] = useState([])
    const [egineFamily, setEngineFamily] = useState([])

    useEffect(() => {
        getEngineFamily()
        if (data?.engine_family) {
            onChangeEngineFamily('', data?.engine_family)
        }
    }, [])

    const onFieldChange = (keyParam, value, extra) => {
        setData({ ...data, [keyParam]: value });

    }
    const onChangeEngineFamily = (keyParam, value) => {
        if (keyParam === 'engine_family' && !value) {
            setData({ ...data, ['engine_family']: '', ['engine_type']: '' });
            setEngineType('')
        } else {
            globalGetService(`camo/engine_dropdown/${value?.id}/`,)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setData({
                            ...data,
                            [keyParam]: value,
                            engine_type: response?.data?.data?.engine_type.filter(item1 =>
                                configData?.engine_type.some(item2 => item1?.id === item2?.id && item1?.name === item2?.name)
                            )
                        });
                        setEngineType(response?.data?.data?.engine_type)
                    } else {
                        setData({ ...data, [keyParam]: value });
                    }
                })
        }
    }
    const onRestErrorKey = (keyParam) => {
        setError({ [keyParam]: '' })
    }
    const getEngineFamily = () => {
        globalGetService(`camo/engine_dropdown/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setEngineFamily(response?.data?.data?.engine_family)
                }
            })
    }

    const onAddNewAsset = () => {
        let validationInputs = {}
        validationInputs = {
            ...validationInputs,
            revision_number: data?.revision_number ? '' : "Please Enter Revision Number",
            engine_family: data?.engine_family ? '' : "Please Select Engine Family",
            engine_type: data?.engine_type?.length > 0 ? '' : "Please Select Engine Type",
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            let payload = Object.assign({}, data);
            if (data?.id) {
                globalPutService(`camo/disclemer_revision/${payload.id}/`, { ...payload, status: true, engine_type: payload?.engine_type ? payload?.engine_type?.map(item => item?.id).join(',') : '', })
                    .then(response => {
                        setLoading(false)
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                            toggleModalFn(); getResponseBack()
                            trackActivity('Disclaimer Data Updated - Airworthiness Management', {
                                event_type: 'Disclaimer Data Updated Success',
                                page_title: 'Disclaimer',
                                id: payload.id || null,
                                success_msg: response?.data?.message
                            })
                        } else {
                            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                            trackActivity('Disclaimer Data Failed - Airworthiness Management', {
                                event_type: 'Disclaimer Data Updated Failed',
                                page_title: 'Disclaimer',
                                id: payload.id || null,
                                error_msg: response?.data?.message
                            })

                        }
                    })
            } else {
                globalPostService(`camo/disclemer_revision/`, { ...payload, status: true, engine_type: payload?.engine_type ? payload?.engine_type?.map(item => item?.id).join(',') : '', })
                    .then(response => {
                        setLoading(false)
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                            toggleModalFn(); getResponseBack()
                            trackActivity('Disclaimer Data Added  - Airworthiness Management', {
                                event_type: 'Disclaimer Data Added Success',
                                page_title: 'Disclaimer',
                                success_msg: response?.data?.message
                            })
                        } else {
                            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                            trackActivity('Disclaimer Data Failed - Airworthiness Management', {
                                event_type: 'Disclaimer Data Added Failed',
                                page_title: 'Disclaimer',
                                error_msg: response?.data?.message
                            })

                        }
                    })

            }
        } else {
            setError(validationInputs)
        }
    }
    return (
        <>
            <Dialog
                open={true}
                onClose={toggleModalFn}
            >
                <DialogTitle> {modeType === "edit" ? "Edit Configure" : modeType === "view" ? "View Configure" : "Add Configure"} </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2} >
                        <Grid item md={3} sm={6} xs={12}>
                            <TextField
                                required
                                variant="outlined"
                                margin='normal'
                                label="Revision Number"
                                id="revision_number"
                                fullWidth
                                disabled={modeType === "view"}
                                error={error?.revision_number ? true : false}
                                helperText={error?.revision_number ? error?.revision_number : ""}
                                inputProps={{ maxLength: 50 }}
                                value={data?.revision_number}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => { onFieldChange("revision_number", e.target.value); onRestErrorKey('revision_number') }}
                            />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                            <Autocomplete
                                id="engine_family"
                                options={egineFamily || []}
                                getOptionLabel={(option) => option?.name}
                                value={data?.engine_family || []}
                                margin='normal'
                                disabled={modeType === "view"}
                                onChange={(e, value) => { onChangeEngineFamily("engine_family", value); onRestErrorKey('engine_family') }}
                                renderInput={(params) => (
                                    <TextField
                                        required
                                        {...params}
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                Engine Family
                                                <Tooltip placement='right' title="Select Engine Family to apply all Engine Types under the family to Engine Type" arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        error={error?.engine_family ? true : false}
                                        helperText={error?.engine_family ? error?.engine_family : ""}
                                        margin='normal'
                                        placeholder="Select Engine Family"
                                        variant="outlined"
                                        fullWidth
                                        disabled={modeType === "view"}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} sm={6} xs={12}>
                            <Autocomplete
                                id="engine_type"
                                options={engineType || []}
                                getOptionLabel={(option) => option?.name}
                                value={data?.engine_type || []}
                                margin='normal'
                                multiple={true}
                                disabled={modeType === "view"}
                                disableCloseOnSelect={true}
                                onChange={(e, value) => { onFieldChange("engine_type", value); onRestErrorKey('engine_type') }}
                                renderInput={(params) => (
                                    <TextField
                                        required
                                        {...params}
                                        error={error?.engine_type ? true : false}
                                        helperText={error?.engine_type ? error?.engine_type : ""}
                                        label="Engine Type"
                                        margin='normal'
                                        placeholder="Select Engine Type"
                                        variant="outlined"
                                        fullWidth
                                        disabled={modeType === "view"}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} sm={6} xs={12}>
                            <TextField
                                variant="outlined"
                                margin='normal'
                                label="Disclaimer Message"
                                id="disclemer_message"
                                fullWidth
                                disabled={modeType === "view"}
                                inputProps={{ maxLength: 255 }}
                                value={data?.disclemer_message}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => onFieldChange("disclemer_message", e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color='primary' size='small' onClick={toggleModalFn}>CLOSE</Button>
                    <Button variant='contained' color='primary' size='small' disabled={modeType === "view"} onClick={onAddNewAsset}>SAVE</Button>
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default AddEditConfigure;